import React from 'react';
import './FormSubmissionStatus.css';
import { useNavigate } from 'react-router';

const FormSubmissionStatus = ({ 
  isSubmitting, 
  submissionResult, 
  onClose, 
  onRetry,
  jobTitle 
}) => {

  const navigate = useNavigate();

  // Don't render if not submitting and no result
  if (!isSubmitting && !submissionResult) {
    return null;
  }

  const LoadingSpinner = () => (
    <div className="loading-spinner">
      <div className="spinner"></div>
    </div>
  );

  const SuccessIcon = () => (
    <div className="success-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
        <polyline points="22,4 12,14.01 9,11.01"></polyline>
      </svg>
    </div>
  );

  const ErrorIcon = () => (
    <div className="error-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="15" y1="9" x2="9" y2="15"></line>
        <line x1="9" y1="9" x2="15" y2="15"></line>
      </svg>
    </div>
  );

  // Submitting state
  if (isSubmitting) {
    return (
      <div className="submission-overlay">
        <div className="submission-modal submitting">
          <LoadingSpinner />
          <h2 className="submission-title">Submitting Job Posting</h2>
          <p className="submission-message">
            Please wait while we process your job posting...
          </p>
          <div className="progress-dots">
            <span className="dot"></span>
            <span className="dot"></span>
            <span className="dot"></span>
          </div>
        </div>
      </div>
    );
  }

  // Success state
  if (submissionResult?.success) {
    return (
      <div className="submission-overlay">
        <div className="submission-modal success">
          <SuccessIcon />
          <h2 className="submission-title">Job Posted Successfully!</h2>
          <p className="submission-message">
            {jobTitle ? `"${jobTitle}"` : 'Your job posting'} has been published and is now live.
          </p>
          
          {submissionResult.jobId && (
            <div className="submission-details">
              <p className="detail-item">
                <span className="detail-label">Job ID:</span>
                <span className="detail-value">{submissionResult.jobId}</span>
              </p>
            </div>
          )}

          <div className="submission-actions">
            <button onClick={() => {navigate(`/job-detail/${submissionResult.jobId}`)}} className="primary-button">
              View Job Posting
            </button>
            <button onClick={onClose} className="secondary-button">
              Create Another Job
            </button>
          </div>
        </div>
      </div>
    );
  }

  // Error state
  if (submissionResult?.error) {
    return (
      <div className="submission-overlay">
        <div className="submission-modal error">
          <ErrorIcon />
          <h2 className="submission-title">Submission Failed</h2>
          <p className="submission-message">
            {submissionResult.message || 'There was an error submitting your job posting. Please try again.'}
          </p>

          {submissionResult.errors && (
            <div className="error-details">
              <h4 className="error-details-title">Details:</h4>
              <ul className="error-list">
                {submissionResult.errors.map((error, index) => (
                  <li key={index} className="error-item">{error}</li>
                ))}
              </ul>
            </div>
          )}

          <div className="submission-actions">
            <button onClick={onRetry} className="primary-button">
              Try Again
            </button>
            <button onClick={onClose} className="secondary-button">
              Go Back to Edit
            </button>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default FormSubmissionStatus;